var path = require('path');
var url = require('url');

function rebaseRemoteMap(sourceMap, sourceUri) {
  var sourceDirectory = path.dirname(sourceUri);

  sourceMap.sources = sourceMap.sources.map(function(source) {
    return url.resolve(sourceDirectory, source);
  });

  return sourceMap;
}

module.exports = rebaseRemoteMap;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/reader/rebase-remote-map.js
// module id = 292
// module chunks = 0 1